export default __webpack_public_path__ + "static/media/marker-icon-green.be46e8d9.png";